import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Communities',
    href: '#communities'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md py-3' : 'bg-transparent py-6'}`} data-id="element-141">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between" data-id="element-142">
        {/* Logo */}
        <div className="flex flex-col" data-id="element-143">
          <a href="#" className={`font-heading font-bold text-xl tracking-widest uppercase ${isScrolled ? 'text-brand-dark' : 'text-white'}`} data-id="element-144">
            Donavan Smith
          </a>
          <span className={`text-[10px] tracking-[0.2em] uppercase ${isScrolled ? 'text-brand-gold' : 'text-gray-300'}`} data-id="element-145">
            Real Estate Agent
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-146">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium uppercase tracking-wide transition-colors hover:text-brand-gold ${isScrolled ? 'text-brand-dark' : 'text-white/90'}`} data-id="element-147">
              {link.name}
            </a>)}
          <Button variant={isScrolled ? 'primary' : 'outline'} size="sm" onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-148">
            Contact Me
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-149">
          {isMobileMenuOpen ? <X className={isScrolled ? 'text-brand-dark' : 'text-white'} data-id="element-150" /> : <Menu className={isScrolled ? 'text-brand-dark' : 'text-white'} data-id="element-151" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-white shadow-xl p-6 md:hidden flex flex-col space-y-4 animate-in slide-in-from-top-5" data-id="element-152">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-dark font-medium uppercase tracking-wide py-2 border-b border-gray-100" onClick={() => setIsMobileMenuOpen(false)} data-id="element-153">
              {link.name}
            </a>)}
          <Button fullWidth onClick={() => {
        setIsMobileMenuOpen(false);
        document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} data-id="element-154">
            Contact Me
          </Button>
        </div>}
    </header>;
}